import React from "react";

import {GraphQlSelect} from "./GraphQlSelect";
import {usePostInstructionQueryQuery} from "../../generated/graphql";

export const PanelPostInstructionsSelect = (props) => {
    const query = usePostInstructionQueryQuery();
    return <GraphQlSelect queryResult={query} {...props}  labelField="label" />;
}
